<template>
    <div class='ba-sidebar'>
        <ul class='ba-nav'>
            <li class='ba-nav-item'>
              <component 
                :is="isBundle ? 'a' : 'router-link'" 
                v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Dashboard' }}"
                class="ba-link"
                :class="{
                  'ba-is-active': !isBundle && $route.name === 'Dashboard',
                  'ba-disabled': isBundle
                }"
              >
                <builderall-icon code="sitebuilder"></builderall-icon>
                <span class="ba-title">{{ $t('ct-dashboard') }}</span>
              </component>
            </li>
            <li class='ba-nav-item'>
              <component 
                :is="isBundle ? 'a' : 'router-link'" 
                v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'CreateWebsite', query: { step: 'template' }}}"
                class="ba-link"
                :class="{
                  'ba-is-active': !isBundle && $route.name == 'CreateWebsite',
                  'ba-disabled': isBundle
                }"
              >
                <builderall-icon code='2780'></builderall-icon>
                <span class='ba-title'>{{ $t('ct-new-website') }}</span>
              </component>
            </li>
            <li class='ba-nav-item' v-if="Object.keys(website).length && (isExpandedWebsite())">
                <input 
                  type='checkbox' 
                  :disabled="isExpandedWebsite()" 
                  checked
                  class='ba-nav-item-input-status' 
                  id='ba-toggle-expandable-content-2'
                >
                <label class='ba-nav-item-expandable' for='ba-toggle-expandable-content-2'>
                    <div class='ba-nav-item-expandable-content'>
                        <builderall-icon code='7faf'></builderall-icon>
                        <span class='ba-title'>{{ $t('ct-my-websites') }}</span>
                        <builderall-icon code='5da4' class='ba-link-expandable-icon' />
                    </div>
                    <ul class='ba-nav-subitems'>
                        <hr class='ba-hr-row'>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Home' } }"
                            class="ba-nav-subitem-link ba-back"
                            :class="{
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='arrow-left'></builderall-icon>
                            <span class='ba-title'>{{ $t('ct-all-websites') }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem'>
                            <a class='ba-nav-subitem-link ba-current-section'>
                                <span class='ba-title'>{{ website.title }}</span>
                            </a>
                        </li>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'SitePages', params: { id: website.encrypted_id, data: website }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'site-pages',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='pages'></builderall-icon>
                            <span class='ba-title'>{{ $t('ct-my-pages') }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'GeneralSettings', params: { id: website.encrypted_id, data: website }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'general-settings',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='general-settings'></builderall-icon>
                            <span class="ba-title">{{ $t('ct-website-settings') }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem'>
                            <router-link class="ba-nav-subitem-link" 
                                :class="{ 'ba-is-active': active == 'items' }"
                                :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id }}"
                            >
                              <builderall-icon code='elements'></builderall-icon>
                              <span class="ba-title">{{ $t('ct-items-all-edit') }}</span>
                            </router-link>
                        </li>
                        <li class='ba-nav-subitem' v-if="showMembersArea">
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'SiteMembers', params : { website_id : website.encrypted_id , data: website  }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'site-members',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='profile'></builderall-icon>
                            <span class="ba-title">{{ $t('ct-members-area') }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem' v-if="showMembersArea">
                            <router-link 
                              class="ba-nav-subitem-link" 
                              :class="{ 'ba-is-active': active == 'form-members' }"
                              :to="{ name: 'FormMembers', params : { website_id : website.encrypted_id , data: website  } }"
                            >
                              <builderall-icon code='member'></builderall-icon>
                              <span class="ba-title">{{ $t('ct-members-form') }}</span>
                            </router-link>
                        </li>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Integrations', params: { id: website.encrypted_id, data: website }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'integrations',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='integrations'></builderall-icon>
                            <span class="ba-title">{{ $t('ct-integrations') }}</span>
                          </component>
                        </li>
                        <li class="ba-nav-subitem">
                            <a 
                              :class="{ 'ba-disabled': tokenCheckout === false || isBundle }" 
                              class="ba-nav-subitem-link"
                              v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : {}"
                              @click.prevent="!isBundle && openSupercheckout()"
                            >
                              <builderall-icon code='checkout'></builderall-icon>
                              <span class="ba-title">{{ $t('ct-supercheckout')}}</span>
                            </a>
                        </li>
                        <li class="ba-nav-subitem">
                            <a
                              :class="{ 'ba-disabled': isBundle }" 
                              class="ba-nav-subitem-link"
                              v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : {}"
                              @click.prevent="!isBundle && openBlog()"
                            >
                              <builderall-icon code='blog'></builderall-icon>
                              <span class="ba-title">{{ $t('ct-blog') }}</span>
                            </a>
                        </li>
                        <li class="ba-nav-subitem">
                            <a 
                              :class="{ 'ba-disabled': isBundle }" 
                              class="ba-nav-subitem-link" 
                              v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : {}"
                              @click.prevent="!isBundle && openBooking()"
                            >
                              <builderall-icon code='booking'></builderall-icon>
                              <span class="ba-title">{{ $t('ct-booking') }}</span>
                            </a>
                        </li>
                        <li class="ba-nav-subitem">
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Domain', params: {id: website ? website.encrypted_id : websiteObj.encrypted_id}}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'domain',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='dns'></builderall-icon>
                            <span class="ba-title">{{ $t("ct-domain") }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Analytics', params: { id: website.encrypted_id, data: website }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'analytics',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='601d'></builderall-icon>
                            <span class="ba-title">{{ $t('ct-gdpr-analytics-type') }}</span>
                          </component>
                        </li>
                        <li class='ba-nav-subitem'>
                          <component 
                            :is="isBundle ? 'a' : 'router-link'" 
                            v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Others', params: { id: website.encrypted_id, data: website }}}"
                            class="ba-nav-subitem-link"
                            :class="{
                              'ba-is-active': !isBundle && active === 'others',
                              'ba-disabled': isBundle
                            }"
                          >
                            <builderall-icon code='others'></builderall-icon>
                            <span class="ba-title">{{ $t('ct-others') }}</span>
                          </component>
                        </li>
                    </ul>
                </label>
            </li>
            <li class='ba-nav-item' v-else>
              <component 
                :is="isBundle ? 'a' : 'router-link'" 
                v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Home' }}"
                class="ba-link"
                :class="{
                  'ba-is-active': !isBundle && $route.name == 'Home',
                  'ba-disabled': isBundle
                }"
              >
                <builderall-icon code='7faf'></builderall-icon>
                <span class='ba-title'>{{ $t('ct-my-websites') }}</span>
              </component>
            </li>
            <li class='ba-nav-item' v-if="!firstWebsite">
              <component 
                :is="isBundle ? 'a' : 'router-link'" 
                v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'Tags' }}"
                class="ba-link"
                :class="{
                  'ba-is-active': !isBundle && $route.name == 'Tags',
                  'ba-disabled': isBundle
                }"
              >
                <builderall-icon code='7347'></builderall-icon>
                <span class='ba-title'>{{ $t('ct-create-tag-group') }}</span>
              </component>
            </li>
            <li class='ba-nav-item'>
              <component 
                :is="isBundle ? 'a' : 'router-link'" 
                v-bind="isBundle ? { href: goToUpgrade(), target: '_blank' } : { to: { name: 'UserSettings' }}"
                class="ba-link"
                :class="{
                  'ba-is-active': !isBundle && $route.name == 'UserSettings',
                  'ba-disabled': isBundle
                }"
              >
                <builderall-icon code='general-settings'></builderall-icon>
                <span class='ba-title'>{{ $t('ct-general-settings') }}</span>
              </component>
            </li>
        </ul>
        <div class='ba-bottom'>
            <ul class='ba-bottom-list'>
                <li>
                    <builderall-help></builderall-help>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { apiUrl, auth as supercheckoutAuth } from '../../js/services/integrations-internas/supercheckout';

import {mapGetters} from 'vuex';
import axios from 'axios';

export default {
  name: 'SiteSidebar',
 
  data() {
    return {
      active: '',
      betaTester: false,
      tokenCheckout: false,
      errorToken: null,
      websiteObj: {},
      isBundle: false
    };
  },

  watch: {
    $route: function(route) {
      if (route.name) this.setActiveRouteName(route.name, route.params);
    },
    'website.encrypted_id': function(website) {
      this.getSuperCheckoutAuth();
    }
  },

  methods: {
    goToUpgrade(){
      return "https://checkout.builderall.com/plans";
    },
    isExpandedWebsite(){
      let status = ['site-pages', 'site-settings', 'domain', 'items', 'general-settings', 'analytics', 'integrations', 'others', 'site-page-create', 'cheetah-turbo-page', 'site-page-edit', 'site-page-versions', 'site', 'site-members', 'form-members'];
      return status.find(x => x == this.active || this.active.startsWith(x));
    },
    openSupercheckout() {
      supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;

            return window.open(`${apiUrl()}?token=${this.tokenCheckout}`);
          } else {
            this.errorToken = error;
          }
        });
    },
    getBlogUrl() {
      const baseURLs = {
          'local':'http://blog.localhost',
          'io'   :'https://blog.kub.app.builderall.io',
          'info' :'https://blog.kub.app.builderall.info',
          'com'  :'https://blog.builderall.com'
      }

      let url = ''

      if(window.location.host.includes('localhost:')) {
        url = baseURLs.local
      } else {
        url = baseURLs[
          window.location.host.includes('.com') ? 'com' : (
            window.location.host.includes('.info') ? 'info' : 'io'
          )
        ]
      }

      return `${url}/logincheetah-login?token=J0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9`
    },
    openBlog() {
      let url = this.getBlogUrl();
      url = url + '&website_id=' + this.website.encrypted_id;
      window.open(url, '_blank');
    },

    checkBlogAceess() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        let vm = this;
        vm.betaTester = true;
        let url = this.getBlogUrl();
        url = url + '&website_id=' + this.website.encrypted_id;
        axios.get(url + '&checkIsBeta=true')
          .then(({data}) => {
            if (data.beta_tester) {
              vm.betaTester = true;
            }
          });
      }
    },

    getSuperCheckoutAuth() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        var error = this.$t('ct-checkout-erro-retrieving-token');
        supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;
          } else {
            this.errorToken = error;
          }
        });
      }
    },

    setActiveRouteName(routeName, params) {
      if (typeof params.type_item !== 'undefined' && params.type_item.length) {
        routeName = `${routeName}-${params.type_item}`;
      }

      this.active = routeName.replace(/(?:^|\.?)([A-Z])/g, function(x, y) {
        return '-' + y.toLowerCase();
      }).replace(/^-/, '');
    },
    openBooking() {
      let token = localStorage.getItem('token') || false;
      let user = this.getUser;

      if (token && user && parseInt(user.id_office_user)) {
        let urlWeb = (process.env.NODE_ENV === 'development' || location.hostname === 'editor-dev.builderall.io') ?
            'https://office.builderall.io/us/office/booking' :
            'https://office.builderall.com/us/office/booking';

        const form = document.createElement('form');
        
        form.method = 'GET';
        form.action = urlWeb;
        form.target = '_blank';
        form.id = 'form-booking';

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    },
  },

  created() {
    this.getSuperCheckoutAuth();
    if (this.$route.name) this.setActiveRouteName(this.$route.name, this.$route.params);
  },

  mounted() {
    // Esse plano bundle deve mostrar o exit popup
    this.isBundle = localStorage.getItem('is_bundle') == 'exit-popup';
    
    let vm = this;
    setTimeout(() => {
      vm.getSuperCheckoutAuth();
    }, 2000);
    vm.$forceUpdate();
  },
  computed: {
    ...mapGetters({getUser: 'user', getUserToken: 'token', getOfficeToken: 'getOfficeToken', website: 'website'}),
    showMembersArea() {
      if (typeof this.website !== 'undefined' && typeof this.website.restrict_areas !== 'undefined') return this.website.restrict_areas.length > 0;
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
    .ba-link,
    .ba-nav-item,
    .ba-title,
    a{
        text-decoration: none;
    }
    .ba-disabled{
      opacity: 0.3;
    }
</style>


// WEBPACK FOOTER //
// src/components/general/Sidebar.vue